export default __webpack_public_path__ + "static/media/download1.2e2e0b42.svg";